import React, { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import TestimonialCard from '../ui/TestimonialCard';
import { motion, AnimatePresence } from 'framer-motion';
export default function TestimonialsSection() {
  const testimonials = [{
    quote: 'Dr Syed has a rare ability to combine compassion with precision. His expert witness report was thorough and respected by both parties in court.',
    author: 'Mohammed Khan',
    position: 'Solicitor Advocate (Leeds)'
  }, {
    quote: 'Dr Syed provided a detailed PTSD evaluation for my client. His balanced and evidence-based approach was key in achieving a fair hearing.',
    author: 'K. Zhang',
    position: 'Immigration Lawyer (Surrey)'
  }, {
    quote: "Dr Syed's report was extremely thorough and delivered ahead of schedule. His insights were clear, impartial, and supported our case strongly in court.",
    author: 'Sarah Mitchell',
    position: 'Solicitor (London)'
  }, {
    quote: "Dr Syed's ability to explain complex psychiatric findings in straightforward terms was outstanding. His evidence was crucial in achieving a positive outcome for my client.",
    author: 'Priya Sharma',
    position: 'Solicitor (Birmingham)'
  }, {
    quote: "Dr Syed's capacity assessment was delivered with professionalism and sensitivity. His balanced and well-reasoned report was pivotal in court proceedings.",
    author: 'T. Chen',
    position: 'Family Lawyer (London)'
  }, {
    quote: "I was impressed by Dr Syed's professionalism and deep understanding of psychiatric assessments. His balanced approach provided exactly the clarity we needed.",
    author: 'R. Ahmed',
    position: 'Barrister (Cardiff)'
  }, {
    quote: "Dr Syed's assessment was clear, comprehensive, and highly professional. His expertise helped the court to make an informed decision with confidence.",
    author: 'A. Patel',
    position: 'Solicitor (Manchester)'
  }, {
    quote: 'Working with Dr Syed was seamless. He communicated promptly, delivered on time, and his report was impartial and well-structured. I would not hesitate to instruct him again.',
    author: 'Emily Roberts',
    position: 'Legal Aid Caseworker (Birmingham)'
  }];
  const [currentPage, setCurrentPage] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  // Check if we're on mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  // Calculate testimonials per page based on screen size
  const testimonialsPerPage = isMobile ? 1 : 3;
  const totalPages = Math.ceil(testimonials.length / testimonialsPerPage);
  const nextPage = () => {
    setCurrentPage(prev => (prev + 1) % totalPages);
  };
  const prevPage = () => {
    setCurrentPage(prev => (prev - 1 + totalPages) % totalPages);
  };
  // Auto-scroll testimonials every 8 seconds (increased from default)
  useEffect(() => {
    const interval = setInterval(() => {
      nextPage();
    }, 8000);
    return () => clearInterval(interval);
  }, [currentPage]);
  const currentTestimonials = testimonials.slice(currentPage * testimonialsPerPage, (currentPage + 1) * testimonialsPerPage);
  return <section className="py-16 bg-white" data-id="element-255">
      <div className="container mx-auto px-4" data-id="element-256">
        <h2 className="text-3xl font-serif font-bold text-primary text-center mb-12" data-id="element-257">
          Testimonials
        </h2>
        <div className="relative" data-id="element-258">
          <AnimatePresence mode="wait" data-id="element-259">
            <motion.div key={currentPage} initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0
          }} transition={{
            duration: 0.5
          }} className={`grid ${isMobile ? 'grid-cols-1' : 'grid-cols-1 md:grid-cols-3'} gap-8`} data-id="element-260">
              {currentTestimonials.map((testimonial, index) => <TestimonialCard key={index} quote={testimonial.quote} author={testimonial.author} position={testimonial.position} data-id="element-261" />)}
            </motion.div>
          </AnimatePresence>
          {/* Navigation controls */}
          <div className="flex justify-center mt-8 space-x-4" data-id="element-262">
            <button onClick={prevPage} className="p-3 rounded-full bg-gray-200 text-primary hover:bg-primary hover:text-white transition-colors focus:ring-2 focus:ring-secondary" aria-label="Previous testimonial" data-id="element-263">
              <ChevronLeft className="h-6 w-6" data-id="element-264" />
            </button>
            <div className="flex space-x-2 items-center" data-id="element-265">
              {Array.from({
              length: totalPages
            }).map((_, index) => <button key={index} onClick={() => setCurrentPage(index)} className={`w-3 h-3 rounded-full focus:ring-2 focus:ring-secondary ${currentPage === index ? 'bg-primary' : 'bg-gray-300'}`} aria-label={`Go to testimonial page ${index + 1}`} data-id="element-266" />)}
            </div>
            <button onClick={nextPage} className="p-3 rounded-full bg-gray-200 text-primary hover:bg-primary hover:text-white transition-colors focus:ring-2 focus:ring-secondary" aria-label="Next testimonial" data-id="element-267">
              <ChevronRight className="h-6 w-6" data-id="element-268" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}